import { Component } from 'react';
import styled from 'styled-components';
import { Row, Col, message } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { TransactionTypeChooser, DiamondSizeChooser } from '../Choosers';
import { Switch, Input } from '../../common';
import FormElement from '../Choosers/FormElement';
import { RedirectToDescriptionSection } from '../RedirectTo';

import { actionTypes, quoteStore } from '../../../store';

const { CurrencyInputNumber, ControlledFormTextArea } = Input;

type Props = { subCategories: string[] } & RouteComponentProps & WithCategoriesProps;

type State = {
  transactionType?: TransactionType;
  hasBoxAndPapers: boolean;
  originalPrice: number;
  isLoginModalVisible: boolean;
  isRegisterModalVisible: boolean;
  diamondSize?: string;
  sizeDescription: string;
  groupType?: TransactionType;
};

class DiamondForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      transactionType: undefined,
      originalPrice: 0,
      isRegisterModalVisible: false,
      isLoginModalVisible: false,
      hasBoxAndPapers: true,
      diamondSize: undefined,
      sizeDescription: '',
    };
  }

  componentDidMount() {
    this.handleValidPackageType();
  }

  render() {
    const {
      transactionType,
      hasBoxAndPapers,
      originalPrice,
      diamondSize,
      sizeDescription,
      groupType,
    } = this.state;

    const store = quoteStore.getState();

    return (
      <>
        <Container className="container">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <TransactionTypeChooser
                selectedType={groupType || transactionType}
                quoteArray={store.quotes}
                onTransactionTypeChange={this.handleTransactionTypeChange}
              />
              <DiamondSizeChooser onChange={this.handleDiamondSizeChange} selectedSize={diamondSize} />
              <Switch
                onChange={this.handleBoxAndPapersChange}
                title="Are there other large diamonds?"
                values={['Yes', 'No']}
                value={hasBoxAndPapers}
              />
              {hasBoxAndPapers && (
                <FormElement title="Are stones the same size? Please provide as much detail about additional diamonds.">
                  <ControlledFormTextArea
                    value={sizeDescription}
                    onChange={this.handleChangeSizeDescription}
                  />
                </FormElement>
              )}
              <FormElement title="What is the original price of the item? (optional)">
                <CurrencyInputNumber value={originalPrice} onChange={this.handleChangeOriginalPrice} />
              </FormElement>
            </Col>
          </Row>
        </Container>
        <RedirectToDescriptionSection
          onClick={this.handleFinish}
          handleValidateForm={this.handleValidateForm}
          category="jewelry"
          subcategory={this.props.subCategoriesString}
        />
      </>
    );
  }

  handleValidPackageType = () => {
    const { quotes } = quoteStore.getState();
    if (quotes.length === 0)
      return;
    const type = quotes[0].generalInfo.transactionType;
    this.setState({ groupType: type, transactionType: type });
  };

  handleValidateForm = (): boolean => {
    const {
      sizeDescription, diamondSize, transactionType, hasBoxAndPapers,
    } = this.state;

    if (!transactionType) {
      message.warn('Transaction type not selected');
      return false;
    }

    if (!diamondSize) {
      message.warn('You must choose the size of the largest diamond');
      return false;
    }

    if (!sizeDescription && hasBoxAndPapers) {
      message.warn('You are not provided detail about additional diamonds');
      return false;
    }
    return true;
  };

  handleFinish = () => {
    if (!this.handleValidateForm()) return;

    const {
      hasBoxAndPapers, originalPrice, sizeDescription, diamondSize, transactionType, groupType,
    } = this.state;

    const { categories } = this.props;
    quoteStore.dispatch({
      type: actionTypes.ADD_GENERAL_INFO,
      generalInfo: {
        categories,
        hasBoxAndPapers,
        originalPrice,
        sizeDescription,
        diamondSize,
        transactionType: groupType || transactionType,
      },
    });
  };

  handleTransactionTypeChange = (transactionType: TransactionType) => {
    this.setState(prevState => {
      if (prevState.transactionType === transactionType) {
        return { transactionType: undefined };
      }
      return {
        transactionType,
      };
    });
  };

  handleChangeOriginalPrice = (value: number) => this.setState({ originalPrice: value });

  handleDiamondSizeChange = (size: string) => this.setState({ diamondSize: size });

  handleRegisterModalVisibilityChange = (isVisible: boolean) => this.setState({ isRegisterModalVisible: isVisible });

  handleLoginModalVisibilityChange = (isVisible: boolean) => this.setState({ isLoginModalVisible: isVisible });

  handleBoxAndPapersChange = (value: boolean) => this.setState({ hasBoxAndPapers: value });

  handleChangeSizeDescription = (description: string) => this.setState({ sizeDescription: description });

  handleSubmit = () => { };
}

const Container = styled.div`
    background-color: #ffffff;
    padding-bottom: 100px;
    .ant.col {
      div {
        max-width: 80%;
      }
    }
`;

export default DiamondForm;
